import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=3d607e28"
import script from "./CreateEventModal.vue?vue&type=script&lang=js"
export * from "./CreateEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports